import React from 'react';

// Base widget class
class ArticleWidget extends React.Component {
  constructor(props) {
    super(props);

    this.didRemoveWidget = this.didRemoveWidget.bind(this);
    this.onChange = this.onChange.bind(this);
    this.moveWidgetUp = this.moveWidgetUp.bind(this);
    this.moveWidgetDown = this.moveWidgetDown.bind(this);
  }

  didRemoveWidget() {
    this.props.didRemoveWidget(this.props.index);
  }

  didUpdateWidget() {
    this.props.didUpdateWidget(this.props.index, this.props.data);
  }

  // very easy - len sprosty update, kazda nie easy podtrieda by to mala pretazit
  onChange(event) {
    let data = this.props.data;
    data[event.target.name] = event.target.value;
    this.props.didUpdateWidget(this.props.index, data);
  }

  moveWidgetUp() {
    this.props.moveWidget(this.props.index, 'up');
  }

  moveWidgetDown() {
    this.props.moveWidget(this.props.index, 'down');
  }

  render() {
    return (
      <div className="panel panel-default widget-body">
        <div className="panel-heading clearfix">
          <div className="btn-group">
            <button
              className="btn btn-default btn-sm"
              onClick={this.moveWidgetUp}
              disabled={this.props.index === 0}
            >
              <i className="fa fa-arrow-up" />
            </button>
            <button
              className="btn btn-default btn-sm"
              onClick={this.moveWidgetDown}
              disabled={this.props.isLast}
            >
              <i className="fa fa-arrow-down" />
            </button>
          </div>
          <strong className="panel-title"> {this.props.name}</strong>
          <a
            onClick={this.didRemoveWidget}
            href="javascript:void(0);"
            className="btn btn-danger btn-sm pull-right"
          >
            <i className="fa fa-times" />
          </a>
        </div>
        <div className="panel-body">{this.renderWidget()}</div>
      </div>
    );
  }
  // render() {
  //     const { connectDragSource, isDragging } = this.props;
  //     console.log(connectDragSource);
  //     return connectDragSource(<div style={{
  //         opacity: isDragging ? 0.5 : 1
  //     }}>
  //         {this.renderWidget()}
  //     </div>);
  // }
}
ArticleWidget.defaultProps = {
  data: {},
  name: '',
  index: null,
  preview: false,
};

export default ArticleWidget;



// WEBPACK FOOTER //
// ./src/js/app/cm/components/ArticleWidgets/ArticleWidget.jsx